// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be0d2136","453":"abd36b29","455":"73cf0f9f","644":"c54937bd"}[chunkId] + ".chunk.js";
};